export default __webpack_public_path__ + "static/media/article2.c2f770ee.png";